module.exports = __webpack_public_path__ + "media/images/bg/mosaic/sencha-62401ba303b19b7bf0eac6fe29e8ccb3.jpg";